import InfoTip from "../../components/InfoTip";
import { ReactComponent as HelpIcon } from "../../static/assets/dashboard-help.svg";
import styles from "./HighlightCard.module.css";

const HighlightCard = ({ iconSrc, icon, title, hint, value }) => (
  <article className={styles.card}>
    <div className={styles.icon} aria-hidden="true">
      {icon || <img src={iconSrc} alt="" className={styles.glyph} />}
    </div>
    <div className={styles.body}>
      <div className={styles.titleRow}>
        <p
          className={styles.title}
          title={typeof title === "string" ? title : undefined}
        >
          {title}
        </p>
        {hint ? (
          <span className={styles.hint}>
            <InfoTip icon={HelpIcon} nudgeY={-1}>
              {hint}
            </InfoTip>
          </span>
        ) : null}
      </div>
      <p className={styles.value}>{value}</p>
    </div>
  </article>
);

export default HighlightCard;
